import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=6528b4d6&scoped=true&"
import script from "./GlobalAlert.vue?vue&type=script&lang=js&"
export * from "./GlobalAlert.vue?vue&type=script&lang=js&"
import style0 from "./GlobalAlert.vue?vue&type=style&index=0&id=6528b4d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6528b4d6",
  null
  
)

export default component.exports